import React from 'react'
import { useGlobalContext } from '../context'

const SearchForm = () => {
  const { setSearchTerms } = useGlobalContext()
  const refPrendi = React.useRef(null)

  React.useEffect(() => {
    refPrendi.current.focus()
  }, [])
  const test = () => {
    const newTerms = refPrendi.current.value
    setSearchTerms(newTerms)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
  }

  return (
    <section className='section search'>
      <form action='' className='search-form' onSubmit={handleSubmit}>
        <div className='form-control'>
          <label htmlFor='ciao'>Search Your Favorite Cocktail</label>
          <input ref={refPrendi} id='ciao' type='text' onChange={test} />
        </div>
      </form>
    </section>
  )
}

export default SearchForm
